import { IS_GLOBAL, IS_REGULAR, IS_SINGLE, IS_DELAYED } from '../constants/tasks';

const getTaskType = (isGlobal, isRegular, isDelay) => {
  if (isGlobal) {
    return IS_GLOBAL;
  }
  if (isRegular) {
    return IS_REGULAR;
  }
  if (isDelay) {
    return IS_DELAYED;
  }
  return IS_SINGLE;
};

export default getTaskType;
